// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cal.combo-dmg-cal .chart-container {\n  filter: invert(1);\n  max-width: 500px;\n  width: 100%;\n  margin: 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
